import React, { useState, useEffect } from 'react';

import Request from '~/providers/Request';
import Socket from '~/tools/Socket';

const AttendantWebSocket = React.createContext({
  webSocket: null,
  setWebSocket: () => null,
  attendant: null,
  setAttendant: () => null,
});

export function AttendantWebSocketProvider({ children }) {
  const [webSocket, setWebSocket] = useState(null);
  const [attendant, setAttendant] = useState(null);

  useEffect(() => {
    async function fetchSocket() {
      if (attendant) {
        Socket.onConnect((ws) => {
          const wsUser = ws.subscriptionOrSubscribe(
            `user:${attendant.attributes.uuid}`
          );
          setWebSocket(wsUser);
        });
        Socket.connect().catch(() => {});
      }
    }
    fetchSocket();
  }, [attendant]);

  async function getAttendant() {
    try {
      const response = await Request.get(
        '/admin/user_attendant',
        {},
        { normalizeJSON: false }
      );
      setAttendant(response.data);
    } catch (e) { console.log(e); }
  }

  useEffect(() => {
    getAttendant();
  }, []);

  return (
    <AttendantWebSocket.Provider value={{ webSocket, attendant }}>
      {children}
    </AttendantWebSocket.Provider>
  );
}

export default AttendantWebSocket;
